// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('turbo:frame-load', function() {
  
  $(document).foundation();
  
  $('[data-app-dashboard-toggle-shrink]').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.app-dashboard').toggleClass('shrink-medium').toggleClass('shrink-large');
  });
  
  if( $.cookie('job-menu-expand') == 1 ) {
    console.log('>>>> job-menu-expanded');
    $('#sections-menu').foundation('down', $('.menu.vertical.nested') );
  } else {
    console.log('>>>> job-menu-compacted');
    $('#sections-menu').foundation('up', $('.menu.vertical.nested') );
  }
  
  $(document).on('click', '#jobs-parent', function(event) {
    event.stopPropagation(); // need to stop the clicking several times with every click
    //console.log( 'job menu clicked: ' + $(this).parent().attr('aria-expanded'));
    //console.log('job-menu cookie: ' + $.cookie('job-menu-expand') );
    if( $(this).parent().attr('aria-expanded') == 'false' ) {
      $.cookie('job-menu-expand', 0);
    } else {
      $.cookie('job-menu-expand', 1);
    }
  });
  
  $(document).on('click', '.shrink-medium #app-dashboard-sidebar ul a', function(e) {
    var target = event.target;
    if( $(target).attr('id') != 'jobs-parent') {
      $('#app-dashboard-sidebar').foundation('close');
    }
    
    /* if( $('#app-dashboard-sidebar').width() != '250' ) {
      $('#app-dashboard-sidebar').removeClass('is-open').addClass('is-closed');
      $('#main-body').addClass('is-open-left has-transition-push has-position-left');
    } */
  });
  
  var section = $('#main-body h2').data('section');
  var action = $('#main-body h2').data('action');
  
  section_menu_highlight(section);
  update_main_body_classes(section, action);
});  
  
$('li[data-name="' + $('body').data('section') + '"]').addClass('active');

$(document).on('#sections-menu a', 'click', function() {
  //$('#sections-menu li').removeClass('active');
  $('li[data-name="' + $('body').data('section') + '"]').addClass('active');
  console.log('++++ li[data-name="' + $('body').data('section') + '"]');
});


function section_menu_highlight(section) {
  $('#sections-menu li').removeClass('active');
  $('li[data-name="' + section + '"]').addClass('active');
}

function update_main_body_classes(section, action) {
  var main_body = $('#main-body');
  var fresh_body_classes = "app-body app-dashboard-body-content off-canvas-content has-reveal-left";
  var class_name = 'section-' + section + '-' + action;
  
  $(main_body).attr('class', class_name + ' ' + fresh_body_classes);
}

function close_sidebar_menu() {
  
}